import * as React from 'react';
import loadable from '@loadable/component';
import { LoadingWrapper } from '../Loading';
const PdfViewer = loadable(() => import('src/components/UI/PDFViewer'));

export const InvoiceNotificationDetails: React.FC<{
  invoiceUrl: string;
  loading: boolean;
}> = ({ invoiceUrl, loading }) => {
  return (
    <LoadingWrapper isLoading={loading} hideContentWhileLoading fullHeight>
      <PdfViewer pdfUrl={invoiceUrl} />
    </LoadingWrapper>
  );
};
